import classNames from "classnames";
import { useTranslation } from "react-migration/lib";
import { setActiveSiteReportUtilityStep } from "../../../../../../js/stores/site/actions/setActiveSiteReportUtilityStep";
import { SiteReportUtilitySteps } from "../../../typings/SiteUtilityReport";
import { ErrorIcon } from "../../Icons/ErrorIcon";

export const ErrorPage = () => {
  const { t } = useTranslation();

  const textClassNames = ["atlas-text-sm", "atlas-text-content-primary", "atlas-text-center"];

  return (
    <div data-testid="utility-report-payment-success" className="atlas-p-5">
      <div className="atlas-flex atlas-flex-col atlas-gap-y-2 atlas-py-5">
        <div className="atlas-flex atlas-justify-center">
          <ErrorIcon />
        </div>
        <span className={classNames("atlas-font-semibold", "atlas-pt-5", textClassNames)}>
          {t("sites.utility_report.error_title")}
        </span>
        <span className={classNames(textClassNames)}>
          {t("sites.utility_report.error_message")}
        </span>
        <span className={classNames(textClassNames)}>
          {t("sites.utility_report.error_message_2", {
            tryAgainLink: (
              <span
                onClick={() => setActiveSiteReportUtilityStep(SiteReportUtilitySteps.Overview)}
                className="atlas-font-bold atlas-underline atlas-cursor-pointer"
              >
                {t("sites.utility_report.error_try_again")}
              </span>
            ),
          })}
        </span>
      </div>
    </div>
  );
};
